<template>
    <v-select
        :items="data"
        item-value="id"
        item-text="name"
        :value="value"
        :label="label || $t('attributes.state')"
        @input="$emit('input', $event)"
        :clearable="clearable"
        :outlined="outlined"
        :error-messages="errorMessages"
    >
        <template v-slot:item="{ item }">
            <!-- HTML that describe how select should render items when the select is open -->
            <v-chip :color="item.color" dark>{{ item.name }}</v-chip>
        </template>
        <template v-slot:selection="{ item }">
            <!-- HTML that describe how select should render items when the select is open -->
            <v-chip :color="item.color" dark>{{ item.name }}</v-chip>
        </template>
    </v-select>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "ShipmentStatusesField",
    props: {
        value: [String, Number],
        label: { type: String },
        outlined: { type: Boolean, default: false },
        clearable: { type: Boolean, default: false },
        errorMessages: [String, Array],
        onlyOptions: { type: Array, require: false },
        excludeOptions: { type: Array, require: false }
    },
    computed: {
        ...mapState({
            statuses: state => state.shipment.statuses
        }),

        data() {
            if (this.excludeOptions && this.onlyOptions) {
                throw Error("Do not use exclude-options and only-options togather");
            }

            if (this.excludeOptions) {
                return this.statuses.filter(s => !this.excludeOptions.includes(s.id));
            }

            if (this.onlyOptions) {
                return this.statuses.filter(s => this.onlyOptions.includes(s.id));
            }

            return this.statuses;
        }
    }
};
</script>
